import { CategoryDataRecord } from '../models/categorydatarecord';
export class CategoriesRecord {
    public prodId: number;
    public relId: number;
    public categories: CategoryDataRecord[];
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/categoriesrecord.ts